import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/sagas/funnelChart";
import FUNNEL_CONSTANTS from "../constants";

export const AverageGroup = () => {
  const dispatch = useDispatch();

  const average = useSelector((state) => state.laser.selectedFilters.average);
  const averageGroup = useSelector((state) => state.laser.selectedFilters.averageGroup);

  if (!average || average === FUNNEL_CONSTANTS.AVERAGE_OPTIONS[0]) return null;

  return (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">Group (Average)</p>
      <MultiSelectDropdown
        options={FUNNEL_CONSTANTS.GROUP_OPTIONS}
        selectedFilters={averageGroup}
        numberDisplayed={0}
        onSelectChange={(data) => dispatch(actionCreators.setAverageGroup(data))}
      />
    </div>
  );
};
